import { ProductTypes } from './enums/ProductEnums';

export type EticketDepartmentSaleLine = {
  saleLineId: string;
  skuId: number;
  productCode: string;
  productDescription: string;
  productColour: string;
  productSize: string;
  productType: ProductTypes;
  buyingroupLevel4Code: string;
  quantity: number;
  discount: number;
  sellPrice: number;
  standardPrice: number;
  picture: string;
  url: string;
  brand: string;
  typeId: string;
  colourId: number;
  rootUrl: string;
  idSaleLineReturned: string;
  returned: boolean;
  returnReason: string;
  totalSellPrice: number;
  totalDiscount: number;
  totalStandardPrice: number;
};

export type EticketDepartment = {
  department: string;
  departmentId: number;
  alreadyVoted: boolean;
  rating: number;
  saleLines: Array<EticketDepartmentSaleLine>;
};

export type EticketInformationResponse = {
  saleId: string;
  orderId: string;
  tilroySaleId: string;
  webOrder: false;
  shopName: string;
  saleDate: string;
  totalPrice: number;
  deliveryPrice: number;
  currency: string;
  currencySign: string;
  currencySignHtml: string;
  totalItems: number;
  hasInvoice: boolean;
  returned: boolean;
  type: string;
  idSourceShop: string;
  alreadyVotedOnSale: boolean;
  saleRating: number;
  alreadyVotedOnRegister: boolean;
  registerRating: number;
  alreadySendFeedback: boolean;
  departments: Array<EticketDepartment>;
};
